import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SendEmailRepository from '../../domains/informacionDevolucion/repositories/send-email-repository';
import SendSMSRepository from '../../domains/informacionDevolucion/repositories/send-sms-repository';
import VerifyCodeProvider from '../../domains/informacionDevolucion/repositories/verify-code-repository';

const initialState = {
    tipoEnvio: 0,
    id: 0,
    descripcion: "", 
    statusCorreo: "idle",
    errorCorreo: "",
    statusSMS: "idle",
    errorSMS: "",
    statusVerificar: "idle",
    errorVerificar: "",
};

export const postEnviarCorreo = createAsyncThunk("verifyCode/postEnviarCorreo", async (datosEnvioCorreo) => {
    return await new SendEmailRepository().enviarCorreo(datosEnvioCorreo).then((resp) => { return resp.data; });
});

export const postEnviarSMS = createAsyncThunk("verifyCode/postEnviarSMS", async (datosEnvioSMS) => {
    return await new SendSMSRepository().enviarSMS(datosEnvioSMS).then((resp) => { return resp.data; });
});

export const postVerificarCodigo = createAsyncThunk("verifyCode/postVerificarCodigo", async (datosVerificacion) => {
    return await new VerifyCodeProvider().verificarCodigo(datosVerificacion).then((resp) => { return resp.data; });
});

export const verifyCodeSlice = createSlice({
    name : "verifyCode",
    initialState,
    reducers:{
        setTipoEnvio : (state, action) => {
            state.tipoEnvio = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase( postEnviarCorreo.pending, (state) => {
                state.statusCorreo = "loading";
            })
            .addCase( postEnviarCorreo.fulfilled, (state, action) => {
                state.statusCorreo = "succeeded";
                state.id = action.payload.datos.id;
            })
            .addCase( postEnviarCorreo.rejected, (state, action) => {
                state.statusCorreo = "failed";
                state.errorCorreo = "Ocurrio un error al procesar su solicitud.";
            })
            .addCase( postEnviarSMS.pending, (state) => {
                state.statusSMS = "loading";
            })
            .addCase( postEnviarSMS.fulfilled, (state, action) => {
                state.statusSMS = "succeeded";
                state.id = action.payload.datos.id;
            })
            .addCase( postEnviarSMS.rejected, (state, action) => {
                state.statusSMS = "failed";
                state.errorSMS = "Ocurrio un error al procesar su solicitud.";
            })
            .addCase( postVerificarCodigo.pending, (state) => {
                state.statusVerificar = "loading";
            })
            .addCase( postVerificarCodigo.fulfilled, (state, action) => {
                state.statusVerificar = "succeeded";
            })
            .addCase( postVerificarCodigo.rejected, (state, action) => {
                state.statusVerificar = "failed";
                state.errorVerificar = "Ocurrio un error al procesar su solicitud.";
            });
    }
});

export const { setTipoEnvio } = verifyCodeSlice.actions;
export default verifyCodeSlice.reducer;